import {
  showErrorMsg,
  loadingToast,
  showChargebackSubmitted,
  showMismatchedSubmitted,
  showRefundSubmitted,
  showVoidSubmitted,
  showCancelSubmitted,
  showCaptureSubmitted,
} from "../utils/toast";
import api from "./api";
import { stringifyValues } from "../utils/tableFunctions";
import { Logger } from "../utils/logger";
import toast from "react-hot-toast";
import { formatObject } from "../utils/appUtils";
import { Log, writeLog } from "./services";

// --------------- API Calls for Mismatch ----------------------- //

export async function getMismatchList(
  setList,
  setLoaded,
  download = false,
  filter = {}
) {
  filter = stringifyValues(filter);
  const url = "/reconciled/admin/mismatch/filter/";
  api
    .post(url, {
      ...filter,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (setList) {
        setList(response.data);
        setLoaded && setLoaded(true);
      }
      return response.data;
    });
}

export async function getMismatchCSV(filter) {
  const url = "/reconciled/admin/mismatch/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

export function getMismatchDetails(id, setList, setRefs, setLoaded) {
  const url = `/reconciled/admin/mismatch/details/${id}`;
  api.get(url).then((response) => {
    setList(response.data[0]);
    setRefs(response.data);
    setLoaded(true);
  });
}

export function getMismatchFilterParam(setParams) {
  const url = "/reconciled/admin/mismatch/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

// --------------- API Calls for Reconciled ----------------------- //

export async function getReconciledList(
  setList,
  setLoaded,
  download = false,
  filter = {}
) {
  filter = stringifyValues(filter);
  const url = "/reconciled/admin/reconciliation/filter/";
  api
    .post(url, {
      ...filter,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (setList) {
        setList(response.data);
        setLoaded && setLoaded(true);
      }
      return response.data;
    });
}

export async function getReconciledCSV(filter) {
  const url = "/reconciled/admin/reconciliation/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

export function getReconciledDetails(id, setList, setRefs, setLoaded) {
  const url = `/reconciled/admin/reconciliation/details/${id}`;
  api.get(url).then((response) => {
    setList(response.data[0]);
    setRefs(response.data);
    setLoaded(true);
  });
}

export function getTransactionDetails(id, setList, setRefs, setLoaded) {
  const url = `/reconciled/admin/transaction/details/${id}/`;
  api.get(url).then((response) => {
    setList(response.data[0]);
    setRefs(response.data);
    setLoaded(true);
  });
}

export function getReconciledFilterParam(setParams) {
  const url = "/reconciled/admin/mismatch/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

// --------------- API Calls for Transaction ----------------------- //

export async function getTransactionList(
  setList,
  setLoaded,
  download = false,
  filter = {},
  params = {}
) {
  filter = stringifyValues(filter);
  const queryParams = new URLSearchParams(params).toString();
  const url = `/reconciled/admin/transaction/filter/?${queryParams}`;
  api
    .post(url, {
      ...filter,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (response.status === 200) {
        setList?.(response.data);
      } else {
        showErrorMsg();
      }
      return response.data;
    })
    .finally(() => setLoaded?.(true));
}

export async function getTransactionCSV(filter) {
  const url = "/reconciled/admin/transaction/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

export function getTransactionFilterParam(setParams, setFLoaded) {
  const url = "/reconciled/admin/transaction/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  })
  .finally(() => setFLoaded?.(true));
}

// --------------- API Calls for Chargeback ----------------------- //

export async function getChargebackList(
  setList,
  setLoaded,
  download = false,
  filter = {}
) {
  filter = stringifyValues(filter);
  const url = "/reconciled/admin/mismatch/chargeback/filter/";
  api
    .post(url, {
      ...filter,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (setList) {
        setList(response.data);
        setLoaded && setLoaded(true);
      }
      return response.data;
    });
}

export async function getChargebackCSV(filter) {
  const url = "/reconciled/admin/mismatch/chargeback/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, { download: "true", ...filter });
  return data.data;
}

// export function getChargebackAmount(setResponse) {
//   const url = "/dashboard/recon/mismatch/admin/chargeback/total_amount/";
//   api.get(url).then((response) => {
//     setResponse(response.data);
//   });
// }

export function getChargebackFilterParam(setParams) {
  const url = "/reconciled/admin/mismatch/filter_conditions/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

export function postMismatch({ pk, currency, amount, comment }) {
  const url = "/reconciled/admin/mismatch/reconcile/";
  api
    .post(url, {
      pk: parseInt(pk),
      currency,
      amount: parseFloat(amount).toFixed(2),
      comment,
    })
    .then((response) => {
      if (!response.data.message) {
        showMismatchedSubmitted();
        setTimeout(() => window.close(), 1000);
      } else {
        showErrorMsg(response.data.message);
      }
    });
}

export function postMismatchVoid(id, comment, oxygen7_id) {
  const url = "/dashboard/recon/reconciled/admin/void/";
  const toastId = loadingToast();
  const params = {
    comment: comment,
    pk_list: JSON.stringify([id]),
  }
  const formattedString = formatObject(params)
  writeLog(`[Info] - Click button - Apply Void transaction of id: ${oxygen7_id} - API: ${url} - params: {${formattedString}}`)
  api
    .post(url, params)
    .then((response) => {
      if (!response.data.message) {
        window.location.reload();
        toast.dismiss(toastId);
        showVoidSubmitted();
      } else {
        showErrorMsg(response.data.message);
        Log.error(url, params, response)
      }
    });
}

export function postVoidTransaction(payload = {}) {
  const { pk } = payload;
  const url = "/transaction/void/";
  const toastId = loadingToast();
  const formattedString = formatObject(payload)
  writeLog(`[Info] - Click button - Apply Void transaction of id: ${pk} - API: ${url} - params: {${formattedString}}`)
  api
    .post(url, {
      ...payload,
    })
    .then((response) => {
      if (response.status === 200) {
        window.location.reload();
        toast.dismiss(toastId);
        showVoidSubmitted();
        setTimeout(() => window.close(), 1000);
      } else {
        toast.dismiss(toastId);
        showErrorMsg(response.data.detail.toString());
        Log.error(url, payload, response)
      }
    })
    .catch((err) => {
      toast.dismiss(toastId);
      showErrorMsg(err);
      Log.error(url, payload, err)
    });
}

export function postMismatchChargeback(id, comment, oxygen7_id) {
  const url = "/dashboard/recon/reconciled/admin/chargeback/";
  const toastId = loadingToast();
  const params = {
    comment: comment,
    pk_list: JSON.stringify([id]),
  }
  const formattedString = formatObject(params)
  writeLog(`[Info] - Click button - Apply Chargeback transaction of id: ${oxygen7_id} - API: ${url} - params: {${formattedString}}`)

  api
    .post(url, params)
    .then((response) => {
      if (!response.data.message) {
        window.location.reload();
        toast.dismiss(toastId);
        showChargebackSubmitted();
      } else {
        showErrorMsg(response.data.message);
        Log.error(url, params, response);
      }
    });
}

export function postRefundTransaction(pk, refund_amount, comment) {
  const url = "/transaction/refund/";
  const toastId = loadingToast();
  const params = {
    pk: pk,
    refund_amount: refund_amount,
    comment: comment,
  }
  const formattedString = formatObject(params)
  writeLog(`[Info] - Click button - Apply Refund transaction of id: ${pk} - API: ${url} - params: {${formattedString}}`)
  api
    .post(url, {
      pk: pk,
      refund_amount: refund_amount,
      comment: comment,
    })
    .then((response) => {
      if (response.status === 200) {
        window.location.reload();
        toast.dismiss(toastId);
        showRefundSubmitted();
        setTimeout(() => window.close(), 1000);
        if (response?.data?.transaction_id) {
          window.open(
            `/3/app/details/transaction/${response.data.transaction_id}`,
            "_blank"
          );
        }
      } else {
        toast.dismiss(toastId);
        showErrorMsg(response.data.detail.toString());
        Log.error(url, params, response);
        // setTimeout(() => window.close(), 1000);
        // let id = "20000002066";
        // window.open(`/3/app/details/transaction/${id}`, "_blank");
      }
    })
    .catch((err) => {
      toast.dismiss(toastId);
      showErrorMsg(err);
      Log.error(url, params, err)
    });
}

export function postCancelTransaction(pk, comment, payload = {}) {
  const url = "/transaction/cancel/";
  const toastId = loadingToast();

  api
    .post(url, {
      pk: pk,
      comment: comment,
      ...payload,
    })
    .then((response) => {
      if (response.status === 200) {
        window.location.reload();
        toast.dismiss(toastId);
        showCancelSubmitted();
        setTimeout(() => window.close(), 1000);
      } else {
        toast.dismiss(toastId);
        showErrorMsg(response.data.detail.toString());
      }
    })
    .catch((err) => {
      toast.dismiss(toastId);
      showErrorMsg(err);
    });
}

export function postCaptureTransaction(payload = {}) {
  const { pk } = payload;
  const url = "/transaction/capture/";
  const toastId = loadingToast();
  const formattedString = formatObject(payload)
  writeLog(`[Info] - Click button - Apply Capture transaction of id: ${pk} - API: ${url} - params: {${formattedString}}`)
  api
    .post(url, {
      ...payload,
    })
    .then((response) => {
      if (response.status === 200) {
        window.location.reload();
        toast.dismiss(toastId);
        showCaptureSubmitted();
        setTimeout(() => window.close(), 1000);
      } else {
        toast.dismiss(toastId);
        showErrorMsg(response.data.detail.toString());
        Log.error(url, { id: pk }, response)
      }
    })
    .catch((err) => {
      toast.dismiss(toastId);
      showErrorMsg(err);
      Log.error(url, { id: pk }, err)
    });
}

export function postMismatchPartialRefund(
  id,
  comment,
  amount,
  currency,
  oxygen7_id
) {
  const url = "/dashboard/recon/reconciled/admin/partial_refund/";
  const toastId = loadingToast();
  const params = {
    pk_list: id,
    comment: comment,
    amount: amount,
    currency: currency,
  }
  const formattedString = formatObject(params)
  writeLog(`[Info] - Click button - Apply Partial refund transaction of id: ${id} - API: ${url} - params: {${ formattedString }}`)
  api
    .post(url, params)
    .then((response) => {
      if (!response.data.message) {
        window.location.reload();
        toast.dismiss(toastId);
        showRefundSubmitted();
        window.close();
      } else {
        showErrorMsg(response.data.message);
        Log.error(url, { id }, response)
      }
    });
}

export function postMismatchFullRefund(
  id,
  comment,
  amount,
  currency,
  oxygen7_id
) {
  const url = "/dashboard/recon/reconciled/admin/full_refund/";
  const toastId = loadingToast();
  const params = {
    pk_list: id,
    comment: comment,
    amount: amount,
    currency: currency,
  }
  const formattedString = formatObject(params)
  writeLog(`[Info] - Click button - Apply Full refund transaction of id: ${id} - API: ${url} - params: {${ formattedString }}`)
  api
    .post(url, {
      pk_list: id,
      comment: comment,
      amount: amount,
      currency: currency,
    })
    .then((response) => {
      if (!response.data.message) {
        window.location.reload();
        toast.dismiss(toastId);
        showRefundSubmitted();
      } else {
        showErrorMsg(response.data.message);
        Log.error(url, params, response)
      }
    });
}

export function getChargebackDetails(id, setList, setRefs, setLoaded) {
  const url = `/reconciled/admin/mismatch/chargeback/details/${id}`;
  api.get(url).then((response) => {
    setList(response.data[0]);
    setRefs(response.data);
    setLoaded(true);
  });
}
